import { render, staticRenderFns } from "./income_statement.vue?vue&type=template&id=997f3298&"
import script from "./income_statement.vue?vue&type=script&lang=js&"
export * from "./income_statement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports